"use strict";

module.exports = {
  bHeadingh1FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh1FontSize: '72px',
  bHeadingh1LetterSpacing: '0px',
  bHeadingh1LineHeight: '80px',
  bHeadingh1FontWeight: '500',
  bHeadingh1Color: 'black',
  bHeadingh1FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh1FallbackFontSize: '72px',
  bHeadingh1FallbackLetterSpacing: '0px',
  bHeadingh1FallbackLineHeight: '80px',
  bHeadingh1FallbackFontWeight: '400',
  bHeadingh1FallbackColor: 'black',
  bHeadingh1SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh1SystemFontSize: '72px',
  bHeadingh1SystemLetterSpacing: '0px',
  bHeadingh1SystemLineHeight: '80px',
  bHeadingh1SystemFontWeight: '400',
  bHeadingh1SystemColor: 'black',
  bHeadingh2FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh2FontSize: '56px',
  bHeadingh2LetterSpacing: '0px',
  bHeadingh2LineHeight: '64px',
  bHeadingh2FontWeight: '500',
  bHeadingh2Color: 'black',
  bHeadingh2FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh2FallbackFontSize: '56px',
  bHeadingh2FallbackLetterSpacing: '0px',
  bHeadingh2FallbackLineHeight: '64px',
  bHeadingh2FallbackFontWeight: '400',
  bHeadingh2FallbackColor: 'black',
  bHeadingh2SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh2SystemFontSize: '56px',
  bHeadingh2SystemLetterSpacing: '0px',
  bHeadingh2SystemLineHeight: '64px',
  bHeadingh2SystemFontWeight: '400',
  bHeadingh2SystemColor: 'black',
  bHeadingh3FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh3FontSize: '40px',
  bHeadingh3LetterSpacing: '0px',
  bHeadingh3LineHeight: '48px',
  bHeadingh3FontWeight: '500',
  bHeadingh3Color: 'black',
  bHeadingh3FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh3FallbackFontSize: '40px',
  bHeadingh3FallbackLetterSpacing: '0px',
  bHeadingh3FallbackLineHeight: '48px',
  bHeadingh3FallbackFontWeight: '400',
  bHeadingh3FallbackColor: 'black',
  bHeadingh3SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh3SystemFontSize: '40px',
  bHeadingh3SystemLetterSpacing: '0px',
  bHeadingh3SystemLineHeight: '48px',
  bHeadingh3SystemFontWeight: '400',
  bHeadingh3SystemColor: 'black',
  bHeadingh4FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh4FontSize: '32px',
  bHeadingh4LetterSpacing: '0px',
  bHeadingh4LineHeight: '40px',
  bHeadingh4FontWeight: '500',
  bHeadingh4Color: 'black',
  bHeadingh4FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh4FallbackFontSize: '32px',
  bHeadingh4FallbackLetterSpacing: '0px',
  bHeadingh4FallbackLineHeight: '40px',
  bHeadingh4FallbackFontWeight: '400',
  bHeadingh4FallbackColor: 'black',
  bHeadingh4SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh4SystemFontSize: '32px',
  bHeadingh4SystemLetterSpacing: '0px',
  bHeadingh4SystemLineHeight: '40px',
  bHeadingh4SystemFontWeight: '400',
  bHeadingh4SystemColor: 'black',
  bHeadingh5FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh5FontSize: '24px',
  bHeadingh5LetterSpacing: '0px',
  bHeadingh5LineHeight: '32px',
  bHeadingh5FontWeight: '500',
  bHeadingh5Color: 'black',
  bHeadingh5FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh5FallbackFontSize: '24px',
  bHeadingh5FallbackLetterSpacing: '0px',
  bHeadingh5FallbackLineHeight: '32px',
  bHeadingh5FallbackFontWeight: '400',
  bHeadingh5FallbackColor: 'black',
  bHeadingh5SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh5SystemFontSize: '24px',
  bHeadingh5SystemLetterSpacing: '0px',
  bHeadingh5SystemLineHeight: '32px',
  bHeadingh5SystemFontWeight: '400',
  bHeadingh5SystemColor: 'black',
  bHeadingh6FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh6FontSize: '20px',
  bHeadingh6LetterSpacing: '0px',
  bHeadingh6LineHeight: '28px',
  bHeadingh6FontWeight: '500',
  bHeadingh6Color: 'black',
  bHeadingh6FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh6FallbackFontSize: '16px',
  bHeadingh6FallbackLetterSpacing: '0px',
  bHeadingh6FallbackLineHeight: '24px',
  bHeadingh6FallbackFontWeight: '400',
  bHeadingh6FallbackColor: 'black',
  bHeadingh6SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh6SystemFontSize: '16px',
  bHeadingh6SystemLetterSpacing: '0px',
  bHeadingh6SystemLineHeight: '24px',
  bHeadingh6SystemFontWeight: '400',
  bHeadingh6SystemColor: 'black',
  bLabalcaptionFallbackFontFamily: '"Arial", "ArialMT"',
  bLabalcaptionFallbackFontSize: '12px',
  bLabalcaptionFallbackLetterSpacing: '0px',
  bLabalcaptionFallbackLineHeight: '16px',
  bLabalcaptionFallbackFontWeight: '400',
  bLabalcaptionFallbackColor: 'black',
  bLabelactionFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Bold"',
  bLabelactionFontSize: '16px',
  bLabelactionLetterSpacing: '0px',
  bLabelactionLineHeight: '24px',
  bLabelactionFontWeight: '700',
  bLabelactionTextDecoration: 'underline',
  bLabelactionColor: 'black',
  bLabelactionFallbackFontFamily: '"Arial", "Arial-BoldMT"',
  bLabelactionFallbackFontSize: '16px',
  bLabelactionFallbackLetterSpacing: '0px',
  bLabelactionFallbackLineHeight: '24px',
  bLabelactionFallbackFontWeight: '700',
  bLabelactionFallbackTextDecoration: 'underline',
  bLabelactionFallbackColor: 'black',
  bLabelbuttonFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Bold"',
  bLabelbuttonFontSize: '20px',
  bLabelbuttonLetterSpacing: '0px',
  bLabelbuttonLineHeight: '28px',
  bLabelbuttonFontWeight: '700',
  bLabelbuttonColor: 'black',
  bLabelbuttonFallbackFontFamily: '"Arial", "Arial-BoldMT"',
  bLabelbuttonFallbackFontSize: '20px',
  bLabelbuttonFallbackLetterSpacing: '0px',
  bLabelbuttonFallbackLineHeight: '28px',
  bLabelbuttonFallbackFontWeight: '700',
  bLabelbuttonFallbackColor: 'black',
  bLabelcaptionFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bLabelcaptionFontSize: '12px',
  bLabelcaptionLetterSpacing: '0px',
  bLabelcaptionLineHeight: '16px',
  bLabelcaptionFontWeight: '500',
  bLabelcaptionColor: 'black',
  bLabelformFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bLabelformFontSize: '16px',
  bLabelformLetterSpacing: '0px',
  bLabelformLineHeight: '24px',
  bLabelformFontWeight: '500',
  bLabelformColor: 'black',
  bLabelformFallbackFontFamily: '"Arial", "Arial-BoldMT"',
  bLabelformFallbackFontSize: '16px',
  bLabelformFallbackLetterSpacing: '0px',
  bLabelformFallbackLineHeight: '24px',
  bLabelformFallbackFontWeight: '700',
  bLabelformFallbackColor: 'black',
  bTextparagraphFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Light"',
  bTextparagraphFontSize: '20px',
  bTextparagraphLetterSpacing: '0px',
  bTextparagraphLineHeight: '28px',
  bTextparagraphFontWeight: '300',
  bTextparagraphColor: 'black',
  bTextparagraphFallbackFontFamily: '"Arial", "ArialMT"',
  bTextparagraphFallbackFontSize: '20px',
  bTextparagraphFallbackLetterSpacing: '0px',
  bTextparagraphFallbackLineHeight: '28px',
  bTextparagraphFallbackFontWeight: '400',
  bTextparagraphFallbackColor: 'black',
  bTextparagraphSystemFontFamily: '"Arial", "ArialMT"',
  bTextparagraphSystemFontSize: '16px',
  bTextparagraphSystemLetterSpacing: '0px',
  bTextparagraphSystemLineHeight: '24px',
  bTextparagraphSystemFontWeight: '400',
  bTextparagraphSystemColor: 'black',
  bTextsupportFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Light"',
  bTextsupportFontSize: '16px',
  bTextsupportLetterSpacing: '0px',
  bTextsupportLineHeight: '24px',
  bTextsupportFontWeight: '300',
  bTextsupportColor: 'black',
  bTextsupportFallbackFontFamily: '"Arial", "ArialMT"',
  bTextsupportFallbackFontSize: '16px',
  bTextsupportFallbackLetterSpacing: '0px',
  bTextsupportFallbackLineHeight: '24px',
  bTextsupportFallbackFontWeight: '400',
  bTextsupportFallbackColor: 'black',
  bTextsupportSystemFontFamily: '"Arial", "ArialMT"',
  bTextsupportSystemFontSize: '14px',
  bTextsupportSystemLetterSpacing: '0px',
  bTextsupportSystemLineHeight: '20px',
  bTextsupportSystemFontWeight: '400',
  bTextsupportSystemColor: 'black',
  bTextsupportformFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Light"',
  bTextsupportformFontSize: '14px',
  bTextsupportformLetterSpacing: '0px',
  bTextsupportformLineHeight: '20px',
  bTextsupportformFontWeight: '300',
  bTextsupportformColor: 'black',
  bTextsupportformFallbackFontFamily: '"Arial", "ArialMT"',
  bTextsupportformFallbackFontSize: '14px',
  bTextsupportformFallbackLetterSpacing: '0px',
  bTextsupportformFallbackLineHeight: '20px',
  bTextsupportformFallbackFontWeight: '400',
  bTextsupportformFallbackColor: 'black'
};